
export const USER_ROLE_DEFINITION_DEFINITIONS = "/UserRoleRelation/GetUserRoleRelationPageList"
export const USER_ROLE_DEFINITION_INSERT = "/UserRoleRelation/InsertUserRoleRelation"
export const USER_ROLE_DEFINITION_UPDATE = "/UserRoleRelation/UpdateUserRoleRelation"
export const USER_ROLE_DEFINITION_DELETE = "/UserRoleRelation/DeleteUserRoleRelation"
